import { useCalendarReturn } from '@/components/calendar/calendar-state'
import { ConsoleFrame } from '@/components/console/frame/console-frame'

// The tenant console (app.ringout.ai/dashboard), in the console v3 design: the
// frame is components/console/frame, the screens are pages/dashboard/*.
export function DashboardLayout() {
  // Google's consent screen sends the browser back to whichever page connected it.
  useCalendarReturn()
  return <ConsoleFrame />
}
